const KEY = 'fellowship:last-search'

// Params we don't want to restore — they go stale immediately
const SKIP = new Set(['from', 'to'])

export function saveLastSearch(params: URLSearchParams): void {
  try {
    const toSave = new URLSearchParams()
    for (const [k, v] of params.entries()) {
      if (!SKIP.has(k)) toSave.set(k, v)
    }
    localStorage.setItem(KEY, toSave.toString())
  } catch {
    // localStorage unavailable (private mode, storage full, etc.)
  }
}

export function loadLastSearch(): URLSearchParams | null {
  try {
    const raw = localStorage.getItem(KEY)
    return raw ? new URLSearchParams(raw) : null
  } catch {
    return null
  }
}

export function clearLastSearch(): void {
  try {
    localStorage.removeItem(KEY)
  } catch {
    // ignore
  }
}

const DENOMINATION_KEY = 'fellowship:denomination-filter'

// Persist the user's chosen denomination filter so it sticks across visits.
// Empty string clears the preference (back to "Any denomination").
export function saveDenominationPref(value: string): void {
  try {
    if (value) localStorage.setItem(DENOMINATION_KEY, value)
    else localStorage.removeItem(DENOMINATION_KEY)
  } catch {
    // localStorage unavailable (private mode, storage full, etc.)
  }
}

export function loadDenominationPref(): string {
  try {
    return localStorage.getItem(DENOMINATION_KEY) ?? ''
  } catch {
    return ''
  }
}
